export default __webpack_public_path__ + "static/analysis_member-613d87d28479572a491997d260e7199f.jpg";